<template>
  <div>
    <base-header class="pb-9" type="danger"> </base-header>
    <modal :show.sync="showActivateEncoderModal" size="sm" modal-classes="modal">
      <div class="p-3">
        <h4 class="mb-3">Activate encoder</h4>
        <div class="mb-3">
          <div class="small mb-2">Does the stream contain BBC audio?</div>
          <div class="d-flex">
            <base-button
              size="sm"
              class="mr-2"
              :type="activateHasBbcAudio === true ? 'success' : 'secondary'"
              @click="activateHasBbcAudio = true"
            >
              Yes
            </base-button>
            <base-button
              size="sm"
              :type="activateHasBbcAudio === false ? 'warning' : 'secondary'"
              @click="activateHasBbcAudio = false"
            >
              No
            </base-button>
          </div>
        </div>
        <div class="mb-3">
          <div class="small mb-2">Does the stream contain sponsor logos or adverts?</div>
          <div class="d-flex">
            <base-button
              size="sm"
              class="mr-2"
              :type="activateHasSponsorAds === true ? 'success' : 'secondary'"
              @click="activateHasSponsorAds = true"
            >
              Yes
            </base-button>
            <base-button
              size="sm"
              :type="activateHasSponsorAds === false ? 'warning' : 'secondary'"
              @click="activateHasSponsorAds = false"
            >
              No
            </base-button>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <base-button type="secondary" class="mr-2" @click="showActivateEncoderModal = false">
            Cancel
          </base-button>
          <base-button
            type="primary"
            :disabled="activateHasBbcAudio === null || activateHasSponsorAds === null || activatingEncoder"
            @click="confirmActivateEncoder"
          >
            Activate
          </base-button>
        </div>
      </div>
    </modal>
    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header">
              <div class="h3 mb-0">{{ match.team1Name }} vs {{ match.team2Name }}</div>
            </div>
            <div class="card-body">
              <div class="row">

                <div class="col">
                  {{ venue?.name }}
                </div>
                <div class="col">
                  {{ format.name }}
                </div>
                <div class="col">
                  {{ match.startDate | dateTime }}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <tabs tabNavClasses="nav-pills" type="danger" :value="initialTabTitle">
   

            <tab type="danger" title="Highlights">
              <span slot="title">
                Highlights
              </span>
              <div class="card shadow mt-3">

                <div class="card-body">
                  <div class="row mb-5" v-if="user.roles.archive_uploader">
                    <div class="col">
                      <archive-upload-wrapper boxHeight="90px" :match="match.id"></archive-upload-wrapper>
                    </div>
                  </div>
                  <div class="row align-items-center pb-2" v-if="canAddHighlightsToCollection">
                    <div class="col-12 col-md-6">
                      <base-input class="select-danger">
                        <el-select
                          v-model="selectedHighlightCollectionId"
                          filterable
                          clearable
                          placeholder="Choose collection to add highlights"
                        >
                          <el-option
                            v-for="col in collections"
                            :key="col.id"
                            :label="col.name"
                            :value="col.id"
                          >
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div v-for="(reel, index) in reels" :key="index" class="col-4 mb-4">

                      <reel-card
                        :file="reel"
                        :matchData="match"
                        :enableAddToCollection="canAddHighlightsToCollection"
                        :selectedCollectionId="selectedHighlightCollectionId"
                        :sendingToCollection="!!highlightCollectionPatchInFlight[reel.id]"
                        @send-to-collection="sendHighlightToCollection"
                      ></reel-card>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
            <tab v-if="showLiveTab" title="Live">
              <span slot="title">
                Live
              </span>
              <div class="row mt-3">

                <!-- INPUT CARD -->
                <div class="col-md-6 mb-3">
                  <div class="card shadow h-100">
                    <div class="card-header py-2 d-flex justify-content-between align-items-center">
                      <span class="h5 mb-0">Input</span>
                      <div class="d-flex align-items-center">
                        <!-- Transitioning: starting -->
                        <span v-if="flowIsStarting" class="small text-muted">
                          <i class="fas fa-circle-notch fa-spin mr-1"></i>Starting…
                        </span>
                        <!-- Transitioning: stopping -->
                        <span v-else-if="flowIsStopping" class="small text-muted">
                          <i class="fas fa-circle-notch fa-spin mr-1"></i>Stopping…
                        </span>
                        <!-- Active: show stop button -->
                        <base-button
                          v-else-if="canStopEncoder"
                          type="warning"
                          size="sm"
                          @click="stopEncoder"
                        >
                          Stop
                        </base-button>
                        <!-- Idle: show activate button -->
                        <base-button
                          v-else
                          type="success"
                          size="sm"
                          :disabled="!hasActivatableInput"
                          @click="openActivateEncoderModal"
                        >
                          Activate
                        </base-button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div v-if="inputFlowErrorMessage" class="alert alert-danger small py-2">
                        {{ inputFlowErrorMessage }}
                      </div>
                      <div v-if="autoDeactivateAfterMs" class="alert alert-warning small py-2 mb-2">
                        <strong>Source disconnected</strong> — flow will auto-stop at {{ autoDeactivateTimeStr }} if source does not reconnect.
                      </div>
                      <div v-if="contentQualityImpacted && contentQualityFlags.length" class="alert alert-danger small py-2 mb-2">
                        <strong>Content quality:</strong> {{ contentQualityFlags.join(' · ') }}
                      </div>
                      <div v-if="monitoringCurrent && activeMonitoringAlarms.length" class="alert alert-warning small py-2">
                        <strong>{{ activeMonitoringAlarms.length }} alarm(s):</strong>
                        {{ activeMonitoringAlarms.map((a) => a.reason || a.type).join(' · ') }}
                      </div>

                      <div v-if="isSuperAdmin" class="mb-3">
                        <div class="form-control-label small">Input profile</div>
                        <el-select
                          v-model="liveRoutingInputId"
                          class="w-100"
                          clearable
                          filterable
                          placeholder="Select input profile"
                          :disabled="liveRoutingSaving"
                        >
                          <el-option
                            v-for="inp in inputsEnabled"
                            :key="inp.id"
                            :label="livestreamInputOptionLabel(inp)"
                            :value="inp.id"
                          />
                        </el-select>
                      </div>

                      <div v-if="!hasActivatableInput && !isSuperAdmin" class="text-muted small">
                        No activatable input is configured for this match yet.
                      </div>

                      <div v-if="fixtureInput">
                        <div class="small"><strong>Name:</strong> {{ fixtureInput.name || fixtureInput.id }}</div>
                        <div class="small"><strong>Type:</strong> {{ fixtureInput.type || 'unknown' }}</div>
                        <div v-if="isMediaConnectInput" class="mt-2">
                          <div class="small">
                            <strong>Flow status:</strong>
                            {{ (fixtureInput && fixtureInput.flow_status) || (inputFlowStatus && inputFlowStatus.flowStatus) || (inputFlowLoading ? 'Loading…' : 'Unknown') }}
                          </div>
                          <template v-if="flowIsActive">
                            <div class="small">
                              <strong>Signal:</strong>
                              <span v-if="sourceHealthState">
                                <span :class="sourceHealthConnected ? 'text-success' : 'text-danger'">
                                  {{ sourceHealthConnected ? 'Connected' : sourceHealthState.charAt(0) + sourceHealthState.slice(1).toLowerCase() }}
                                </span>
                                <span v-if="sourceHealthUnhealthy" class="text-warning ml-1">(unhealthy)</span>
                              </span>
                              <span v-else-if="inputFlowStatus && inputFlowStatus.sourceMetadata">
                                {{ inputFlowStatus.sourceMetadata.hasSignal ? 'Connected' : 'No signal' }}
                              </span>
                              <span v-else-if="monitoringCurrent">{{ monitoringCurrent.sourceSignal || 'unknown' }}</span>
                              <span v-else class="text-muted">—</span>
                            </div>
                            <div v-if="activeTr101Errors.length" class="small text-warning mt-1">
                              <strong>TR-101:</strong> {{ activeTr101Errors.join(', ') }}
                            </div>
                            <div v-if="monitoringCurrent || sourceHealthState" class="small">
                              <strong>Health:</strong> {{ displayHealthState }}
                            </div>
                          </template>
                          <template v-if="displaySourceMetadataVideo">
                            <div class="small">
                              <strong>Resolution:</strong>
                              {{ displaySourceMetadataVideo.width }}x{{ displaySourceMetadataVideo.height }}
                              <span v-if="displaySourceMetadataVideo.frameRate"> @ {{ displaySourceMetadataVideo.frameRate }}</span>
                            </div>
                            <div v-if="displaySourceBitrateKbps != null" class="small">
                              <strong>Bitrate:</strong> {{ displaySourceBitrateKbps }} kbps
                            </div>
                            <div v-if="displaySourceMetadataVideo.codec" class="small">
                              <strong>Codec:</strong> {{ displaySourceMetadataVideo.codec }}
                            </div>
                            <div v-if="displaySourceMetadataVideo.scanType" class="small">
                              <strong>Scan:</strong> {{ displaySourceMetadataVideo.scanType }}
                            </div>
                          </template>
                          <template v-else-if="monitoringVideo && sourceHealthConnected">
                            <div v-if="displaySourceBitrateKbps != null" class="small">
                              <strong>Bitrate:</strong> {{ displaySourceBitrateKbps }} kbps
                            </div>
                            <div v-if="monitoringVideo.width && monitoringVideo.height" class="small">
                              <strong>Dimensions:</strong> {{ monitoringVideo.width }}x{{ monitoringVideo.height }}
                            </div>
                            <div v-if="monitoringVideo.scanType" class="small">
                              <strong>Scan type:</strong> {{ monitoringVideo.scanType }}
                            </div>
                          </template>
                          <div v-if="displaySourceMetadataAudio" class="small">
                            <strong>Audio:</strong>
                            {{ displaySourceMetadataAudio.codec || '' }}
                            <span v-if="displaySourceMetadataAudio.channels"> {{ displaySourceMetadataAudio.channels }}ch</span>
                          </div>
                          <div v-if="displaySourceMessages.length" class="small text-warning mt-1">
                            <strong>Source warnings:</strong>
                            {{ displaySourceMessages.map(m => m.message || m.code).join('; ') }}
                          </div>

                          <div class="border rounded p-2 mt-3 bg-light">
                            <div class="small font-weight-bold mb-2">vMix SRT settings</div>
                            <div class="small"><strong>Protocol:</strong> SRT</div>
                            <div class="small"><strong>Mode:</strong> {{ vmixSrtMode }}</div>
                            <div class="small"><strong>Port:</strong> {{ vmixSrtPort }}</div>
                            <div class="small text-break"><strong>Hostname:</strong> {{ vmixSrtEndpoint }}</div>
                            <base-button
                              size="sm"
                              type="secondary"
                              class="mt-2"
                              :disabled="vmixSrtEndpoint === 'Unavailable'"
                              @click="copyVmixEndpoint"
                            >
                              Copy hostname
                            </base-button>
                            <div class="small text-muted mt-2">
                              In vMix, set Output/Stream to SRT and enter Host/IP + Port above.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="!isSuperAdmin" class="text-muted small">
                        No input assigned to this match.
                      </div>

                      <div v-if="isSuperAdmin && isMediaConnectInput && canStopEncoder && takersDirtyForOutputs" class="mt-3">
                        <base-button
                          type="secondary"
                          size="sm"
                          :disabled="liveRoutingApplyOutputs || liveRoutingSaving"
                          @click="applyMediaConnectFlowOutputs"
                        >
                          {{ liveRoutingApplyOutputs ? 'Applying…' : 'Apply outputs to flow' }}
                        </base-button>
                      </div>
                      <div v-if="liveRoutingSaving" class="small text-muted mt-2">Saving…</div>
                    </div>
                  </div>
                </div>

                <!-- TAKERS CARD -->
                <div class="col-md-6 mb-3">
                  <div class="card shadow h-100">
                    <div class="card-header py-2">
                      <span class="h5 mb-0">Takers</span>
                    </div>
                    <div class="card-body">
                      <div v-if="isSuperAdmin" class="mb-3">
                        <div class="form-control-label small">Takers</div>
                        <el-select
                          v-model="liveRoutingTakerIds"
                          class="w-100"
                          filterable
                          multiple
                          collapse-tags
                          placeholder="Select takers"
                          :disabled="liveRoutingSaving"
                        >
                          <el-option
                            v-for="t in takersEnabled"
                            :key="t.id"
                            :label="t.name || t.key || t.id"
                            :value="t.id"
                          />
                        </el-select>
                      </div>

                      <div v-if="fixtureTakers.length">
                        <div v-for="row in fixtureTakers" :key="row.takerId" class="small mb-2">
                          <div><strong>{{ row.name }}</strong></div>
                          <div class="text-muted">
                            {{ row.protocol || 'unknown protocol' }} ·
                            BBC audio {{ row.takeBbcComms ? 'Yes' : 'No' }}
                          </div>
                          <div v-if="String(row.type || '').toLowerCase() === 'brightcove'" class="text-muted">
                            Brightcove status: {{ formatBrightcoveTakerStatus(row.takerId) }}
                            <span v-if="sourceHealthState">
                              · Input source:
                              <span :class="sourceHealthConnected ? 'text-success' : 'text-danger'">
                                {{ sourceHealthConnected ? 'Connected' : sourceHealthState.charAt(0) + sourceHealthState.slice(1).toLowerCase() }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-muted small">
                        No takers configured on this match.
                      </div>

                      <div v-if="brightcovePreviewIframeUrl" class="mt-3 mx--3 mb--3">
                        <div class="px-3 pt-2 pb-1 border-top">
                          <span class="small font-weight-bold">Live preview</span>
                        </div>
                        <div style="position:relative;padding-top:56.25%;">
                          <iframe
                            :src="brightcovePreviewIframeUrl"
                            allowfullscreen
                            allow="encrypted-media"
                            style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"
                          ></iframe>
                        </div>
                      </div>

                      <hr class="my-3">
                      <div class="small font-weight-bold mb-2">Recent alarms</div>
                      <div v-if="monitoringAlarmLoading" class="text-muted small">Loading alarms…</div>
                      <div v-else-if="monitoringAlarms.length">
                        <div v-for="alarm in monitoringAlarms" :key="alarm.id" class="small mb-2">
                          <div>
                            <strong>{{ alarm.type }}</strong>
                            <span class="text-muted">· {{ alarm.status || 'unknown' }}</span>
                          </div>
                          <div class="text-muted">{{ alarm.reason || 'No reason recorded' }}</div>
                        </div>
                      </div>
                      <div v-else class="text-muted small">No recent alarms.</div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="card shadow mt-3">
                <div class="card-header py-2">
                  <span class="h5 mb-0">Stream sessions</span>
                </div>
                <div v-if="!matchLivestreamSessions.length" class="card-body py-3 text-muted small">
                  No stream sessions recorded for this match yet.
                </div>
                <ul v-else class="list-group list-group-flush">
                  <li
                    v-for="session in matchLivestreamSessions"
                    :key="session.id"
                    class="list-group-item px-3 py-2"
                  >
                    <div class="d-flex justify-content-between align-items-start flex-wrap">
                      <div>
                        <span
                          :class="session.flow_lifecycle_status === 'active' || session.session_status === 'active'
                            ? 'badge badge-success mr-2'
                            : 'badge badge-secondary mr-2'"
                        >
                          {{ session.flow_lifecycle_status === 'active' || session.session_status === 'active' ? 'Live' : 'Ended' }}
                        </span>
                        <span v-if="session.auto_deactivate_after && session.session_status === 'active'" class="badge badge-warning mr-2">
                          Source disconnected
                        </span>
                        <span class="small font-weight-bold">
                          {{ sessionTimestamp(session.flow_started_at || session.session_started_at || session.activated_at) }}
                        </span>
                      </div>
                      <div class="small text-muted text-right">
                        <span v-if="session.flow_ended_at || session.session_ended_at">
                          Ended {{ sessionTimestamp(session.flow_ended_at || session.session_ended_at) }}
                        </span>
                        <span v-if="session.total_stream_duration_ms || session.session_active_duration_ms" class="ml-2">
                          · {{ formatStreamDuration(session.total_stream_duration_ms || session.session_active_duration_ms) }}
                        </span>
                      </div>
                    </div>
                    <div class="small text-muted mt-1">
                      <span v-if="session.input_snapshot && session.input_snapshot.name">
                        Input: {{ session.input_snapshot.name }}
                      </span>
                      <span v-if="session.takers_snapshot && session.takers_snapshot.length" class="ml-2">
                        · Takers: {{ session.takers_snapshot.map(t => t.name || t.takerId).join(', ') }}
                      </span>
                    </div>
                    <div class="small text-muted mt-1">
                      <span v-if="session.bbc_comms_declared != null">
                        BBC audio: <strong>{{ session.bbc_comms_declared ? 'Yes' : 'No' }}</strong>
                      </span>
                      <span v-if="session.commercialised_declared != null" class="ml-2">
                        · Commercial: <strong>{{ session.commercialised_declared ? 'Yes' : 'No' }}</strong>
                      </span>
                    </div>
                    <div v-if="session.source_stream_video || session.source_scan_type" class="small text-muted mt-1">
                      <span v-if="session.source_stream_video && session.source_stream_video.width && session.source_stream_video.height">
                        {{ session.source_stream_video.width }}x{{ session.source_stream_video.height }}
                        <span v-if="session.source_stream_video.frameRate"> @ {{ session.source_stream_video.frameRate }}</span>
                      </span>
                      <span v-if="session.source_scan_type || (session.source_stream_video && session.source_stream_video.scanType)" class="ml-1">
                        · {{ session.source_scan_type || session.source_stream_video.scanType }}
                      </span>
                      <span v-if="session.source_stream_video && session.source_stream_video.codec" class="ml-1">
                        · {{ session.source_stream_video.codec }}
                      </span>
                    </div>
                    <div v-if="session.session_shutdown_reason === 'source_disconnect_timeout'" class="small text-warning">
                      Auto-stopped: source disconnected for 15 minutes
                    </div>
                    <div v-if="session.activated_by_email" class="small text-muted">
                      Activated by {{ session.activated_by_display_name || session.activated_by_email }}
                    </div>
                  </li>
                </ul>
              </div>
            </tab>
            <tab v-if="streamClips.length > 0" title="Stream Clips">
              <span slot="title">
                Stream Clips
              </span>

              <div class="card shadow mt-3">
                <div class="card-header">
                  <div class="row align-items-center">
                    <div class="col-4">
                      <base-input class="select-danger">
                        <el-select v-model="inningsFilter" clearable placeholder="Innings">
                          <el-option v-for="option in innings" class="select-danger" :key="option" :label="option"
                            :value="option">
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>
                    <div class="col-4">
                      <base-input class="select-danger">
                        <el-select v-model="typeFilter" clearable placeholder="Type">
                          <el-option v-for="option in types" class="select-danger" :key="option" :label="option"
                            :value="option">
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>

                    <div class="col-4" v-if="players.length > 0">
                      <base-input class="select-danger">
                        <el-select v-model="playerFilter" filterable clearable placeholder="Batter">
                          <el-option v-for="option in players" class="select-danger" :key="option.ellipsePlayerId"
                            :label="option.fullName" :value="option.ellipsePlayerId">
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div class="
                col-12
                d-flex
                justify-content-center
                flex-wrap
                py-2
              ">
                    <div class="mr-4">
                      <p class="card-category">
                        Showing {{ from + 1 }} to {{ to }} of {{ streamClips.length }} entries
                      </p>

                    </div>
                    <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                      :per-page="pagination.chunkSize" :total="streamClips.length"></base-pagination>
                  </div>
                  <div class="row align-items-center pb-2">
                    <div class="col-12 col-md-6">
                      <base-input class="select-danger">
                        <el-select
                          v-model="selectedStreamCollectionId"
                          filterable
                          clearable
                          placeholder="Choose collection to send clips"
                        >
                          <el-option
                            v-for="col in collections"
                            :key="col.id"
                            :label="col.name"
                            :value="col.id"
                          >
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-12 mb-3" v-for="clip in streamClipsChunked" :key="clip.id">

                      <stream-clip
                        :clip="clip"
                        :selectedCollectionId="selectedStreamCollectionId"
                        :sendingToCollection="!!streamClipCollectionPatchInFlight[clip.id]"
                        @send-to-collection="sendStreamClipToCollection"
                      ></stream-clip>

                    </div>
                  </div>
                </div>
              </div>

            </tab>
            <tab v-if="archiveClips.length > 0" title="Archive Clips">
              <span slot="title">
                Archive Clips: {{ archiveClips.length }}
              </span>
              <div class="card shadow mt-3">
                <div class="h3 mb-0">{{ match.team1Name }} vs {{ match.team2Name }}</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-4"><archive-clip v-for="clip in archiveClips" :clip="clip"></archive-clip></div>
                  </div>
                </div>
              </div>
            </tab>
            <tab v-if="recordingsAll.length > 0" title="Recordings">
              <span slot="title">
                Recordings: {{ recordingsAll.length }}
              </span>
              <div class="card shadow mt-3">

                <div class="card-body">
                  <div class="row mb-4" v-for="day, key in recordings">
                    <div class="col-1 h4">Day {{ key }}</div>
    
                        <div class="col-2" v-for="recording in day">
                      <a :href="`#/recording/${recording.id}`" class="btn btn-secondary btn-block">Part {{ recording.part }}</a></div>
         
                    </div>
                    
                </div>
              </div>
            </tab>
         
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/routes/router";
import tabs from "@/components/Tabs/Tabs";
import tab from "@/components/Tabs/Tab";
import dateTime from "../../../filters/dateTime";
import ReelCard from "./Components/ReelCard";
import ArchiveClip from "./Components/ArchiveClip";
import ArchiveUploader from "./Components/ArchiveUploadWrapper";
import { Firebase } from "@/firebase.js";


import StreamClip from './Components/StreamClip.vue'
function londonYmd(d) {
  return d.toLocaleDateString('en-CA', { timeZone: 'Europe/London' })
}

function londonYmdToMs(ymd) {
  const [y, m, day] = ymd.split('-').map(Number)
  return Date.UTC(y, m - 1, day)
}

function londonDaysSince(earlierYmd, laterYmd) {
  return Math.round((londonYmdToMs(laterYmd) - londonYmdToMs(earlierYmd)) / 86400000)
}

export default {
  name: "Match-Page",
  data() {
    return {
      inningsFilter: '',
      playerFilter: '',
      typeFilter: '',
      showActivateEncoderModal: false,
      activateHasBbcAudio: null,
      activateHasSponsorAds: null,
      activatingEncoder: false,
      inputFlowPollTimer: null,
      inputFlowLoading: false,
      inputFlowInFlight: false,
      inputFlowStatus: null,
      inputFlowErrorMessage: '',
      stoppingEncoder: false,
      monitoringAlarmLoading: false,
      pagination: {
        chunkSize: 20,
        currentPage: 1,
      },
      selectedStreamCollectionId: "",
      streamClipCollectionPatchInFlight: {},
      selectedHighlightCollectionId: "",
      highlightCollectionPatchInFlight: {},
      liveRoutingInputId: null,
      liveRoutingTakerIds: [],
      liveRoutingSaving: false,
      liveRoutingSyncing: false,
      liveRoutingApplyOutputs: false,
      takersDirtyForOutputs: false,
      requestedVenueId: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    isSuperAdmin() {
      return Boolean(this.user.roles && this.user.roles.livestream_admin);
    },
    inputsEnabled() {
      const list = this.$store.getters['inputs/array'] || [];
      return list.filter((i) => i && i.id && i.enabled !== false);
    },
    takersEnabled() {
      const list = this.$store.getters['takers/array'] || [];
      return list.filter((t) => t && t.enabled !== false);
    },
    matchId() {
      return this.$route.params.id;
    },
    match() {
      let match = this.$store.getters["matches/byId"](this.$route.params.id);
      if (match) {
        return match
      }
    },
    venue() {
      if (!this.match || this.match.ground == null || this.match.ground === '') {
        return null;
      }
      return this.$store.getters["venues/byId"](this.match.ground) || null;
    },
    format() {
      return this.$store.getters["matchFormats/formatById"](this.match.cricketFormat);
    },
    reels() {
      let reels = this.$store.getters["files/whatByMatch"]({ what: 'match-reel', id: this.match.id });
      return reels.sort((a, b) => {
        if (a.created_at > b.created_at) {
          return -1
        }
        if (a.created_at < b.created_at) {
          return 1
        }
        if (!a.created_at) {
          return -1
        }
        return 0
      })
    },
    streamClips() {
      let clips = this.$store.getters["files/whatByMatch"]({ what: 'match-clip', id: this.match.id });
      // filter
      if (this.inningsFilter) {
        clips = clips.filter(clip => clip.innings === this.inningsFilter)
      }
      if (this.typeFilter) {
        clips = clips.filter(clip => clip.clipType === this.typeFilter)
      }
      if (this.playerFilter) {
        clips = clips.filter(clip => clip.ellipseBatterId === this.playerFilter)
      }
      return clips.sort((a, b) => {
        if (a.created_at > b.created_at) {
          return -1
        }
        if (a.created_at < b.created_at) {
          return 1
        }
        if (!a.created_at) {
          return -1
        }
        return 0
      })
    },
    streamClipsChunked() {
      function getChunk(array, chunkSize, index) {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
          chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks[index];
      }

      return getChunk(this.streamClips, this.pagination.chunkSize, this.pagination.currentPage - 1);

    },
    innings() {
      let clips = this.streamClips
      const uniqueInnings = this.uniquePropertyValues(clips, 'innings')
      return [...uniqueInnings]
    },
    types() {
      let clips = this.streamClips
      const uniqueTypes = this.uniquePropertyValues(clips, 'clipType')
      return [...uniqueTypes]
    },
    players() {
      let clips = this.streamClips
      const uniquePlayers = this.uniquePropertyValues(clips, 'ellipseBatterId')
      let ids = [...uniquePlayers]
      ids.forEach(player => {
        const id = this.$store.getters["players/byProp"]("ellipsePlayerId", player)
        if (!id) {
          this.$store.dispatch("players/fetchAndAdd", {
            where: [["ellipsePlayerId", "==", player]],
          });
        }
      })
      return this.$store.getters["players/byPropMultiple"]("ellipsePlayerId", ids).sort((a, b) => {
        if (a.lastName > b.lastName) {
          return 1
        }
        if (a.lastName < b.lastName) {
          return -1
        }
        if (!a.lastName) {
          return -1
        }
        return 0
      })
    },
    to() {
      let highBound = this.from + this.pagination.chunkSize;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.chunkSize * (this.pagination.currentPage - 1);
    },
    total() {
      return this.streamClips.length > 0
        ? this.streamClips.length
        : this.streamClips.length;
    },
    recordingsAll() {
      return this.$store.getters["files/whatByMatch"]({ what: 'recording', id: this.match.id })
    },
    recordings() {
      let recordings = this.$store.getters["files/whatByMatch"]({ what: 'recording', id: this.match.id })
      const groupedData = recordings.reduce((acc, obj) => {
  const key = obj.day; // Property to group by
  if (!acc[key]) {
    acc[key] = [];
  }
  acc[key].push(obj);
  return acc;
}, {});

// Sort each array
for (const key in groupedData) {
  if (groupedData.hasOwnProperty(key)) {
    groupedData[key].sort((a, b) => a.part - b.part) // Sort by part
  }
}



return groupedData
      // recordings.sort((a, b) => {
      //   if (a.part > b.part) {
      //     return 1
      //   }
      //   if (a.part < b.part) {
      //     return -1
      //   }
      //   if (!a.part) {
      //     return -1
      //   }
      //   return 0
      // })
      // return recordings.sort((a, b) => {
      //   if (a.day > b.day) {
      //     return 1
      //   }
      //   if (a.day < b.day) {
      //     return -1
      //   }
      //   if (!a.day) {
      //     return -1
      //   }
      //   return 0
      // })
    },
    archiveClips() {
      let clips = this.$store.getters["archiveEvents/byMatchId"](this.match.id);
      clips = clips.filter(clip => clip.source === "user");
      return clips;
    },
    showLiveTab() {
      if (!this.user.roles || !this.user.roles.livestream_access) return false;
      if (!this.match || !this.match.startDate) return false;
      const start = this.match.startDate
      const d = start.toDate ? start.toDate() : new Date(start)
      if (Number.isNaN(d.getTime())) return false
      const today = londonYmd(new Date())
      const matchDay = londonYmd(d)
      if (matchDay >= today) return true
      const isMultiDay = this.match.cricketFormat === '1'
      return isMultiDay && londonDaysSince(matchDay, today) <= 5
    },
    /**
     * Active AWS livestream session doc for this match (from synced livestreams; not stored on match).
     */
    activeLivestreamSessionId() {
      const all = Object.values((this.$store.state.livestreams && this.$store.state.livestreams.data) || {})
      const active = all.filter((s) => {
        if (!s || s.matchId !== this.matchId) return false
        if (!(s.provider === 'aws' || s.aws_flow_arn)) return false
        const ended = String(s.session_status || '').toLowerCase() === 'ended'
        return s.aws_active === true && !ended
      })
      if (!active.length) return ''
      active.sort((a, b) => {
        const at = a.updated_at && a.updated_at.toDate ? a.updated_at.toDate().getTime() : 0
        const bt = b.updated_at && b.updated_at.toDate ? b.updated_at.toDate().getTime() : 0
        return bt - at
      })
      return active[0].id || ''
    },
    initialTabTitle() {
      return this.$route.query && this.$route.query.tab === 'live' ? 'Live' : '';
    },
    fixtureInput() {
      const inputId = this.match && this.match.livestreamInputId
      if (!inputId) return null
      return this.$store.getters["inputs/byId"](inputId) || null
    },
    /** Stable key — only changes when the assigned MediaConnect input identity changes. */
    inputFlowPollKey() {
      if (!this.match || !this.match.livestreamInputId) return null
      const inputId = String(this.match.livestreamInputId).trim()
      const inp = this.fixtureInput
      if (inp && String(inp.type || '').toLowerCase() !== 'mediaconnect') return null
      const flowArn = inp && inp.aws_flow_arn ? String(inp.aws_flow_arn).trim() : ''
      return flowArn ? `${inputId}:${flowArn}` : `pending:${inputId}`
    },
    fixtureTakerRows() {
      return (this.match && Array.isArray(this.match.livestreamTakerRoutes))
        ? this.match.livestreamTakerRoutes
        : []
    },
    fixtureTakers() {
      return this.fixtureTakerRows
        .filter((r) => r && r.takerId)
        .map((r) => {
          const t = this.$store.getters["takers/byId"](r.takerId)
          return {
            takerId: r.takerId,
            name: (t && t.name) || r.takerId,
            type: (t && t.type) || '',
            protocol: (t && t.protocol) || '',
            takeBbcComms: r.takeBbcComms !== false,
            brightcoveLiveAssetId: (t && (t.brightcoveLiveAssetId || t.liveAssetId || t.bc_live_id)) || null,
          }
        })
    },
    brightcoveLiveTaker() {
      return this.fixtureTakers.find(
        (t) => String(t.type || '').toLowerCase() === 'brightcove' && t.brightcoveLiveAssetId
      ) || null
    },
    brightcovePreviewIframeUrl() {
      const LIVE_STATES = ['on']
      const taker = this.brightcoveLiveTaker
      if (!taker || !taker.brightcoveLiveAssetId) return null
      if (!this.canStopEncoder) return null
      // Require input source to be connected
      if (!this.sourceHealthConnected) return null
      // Require the poll to confirm Brightcove is in a live state
      const statusRow = this.brightcoveTakerStatusById[taker.takerId]
      if (!statusRow || !LIVE_STATES.includes(String(statusRow.status || '').toLowerCase())) return null
      return `https://players.brightcove.net/4854911276001/default_default/index.html?videoId=${taker.brightcoveLiveAssetId}`
    },
    brightcoveTakerStatusById() {
      const rows = (this.inputFlowStatus && this.inputFlowStatus.brightcoveTakerStatuses) || []
      const byId = {}
      for (const r of rows) {
        if (!r || !r.takerId) continue
        byId[r.takerId] = r
      }
      return byId
    },
    fixtureInputType() {
      return String((this.fixtureInput && this.fixtureInput.type) || '').toLowerCase()
    },
    hasActivatableInput() {
      if (!this.fixtureInput) return false
      if (this.fixtureInputType === 'mediaconnect') {
        return Boolean(this.fixtureInput.aws_flow_arn)
      }
      return false
    },
    isMediaConnectInput() {
      return this.fixtureInputType === 'mediaconnect' && Boolean(this.fixtureInput && this.fixtureInput.aws_flow_arn)
    },
    flowStatus() {
      return String(
        (this.fixtureInput && this.fixtureInput.flow_status) ||
        (this.inputFlowStatus && this.inputFlowStatus.flowStatus) ||
        ''
      ).toUpperCase()
    },
    canStopEncoder() {
      return this.isMediaConnectInput && this.flowStatus === 'ACTIVE'
    },
    flowIsStarting() {
      return this.activatingEncoder ||
        (this.isMediaConnectInput && ['STARTING', 'UPDATING'].includes(this.flowStatus))
    },
    flowIsStopping() {
      return this.stoppingEncoder ||
        (this.isMediaConnectInput && this.flowStatus === 'STOPPING')
    },
    // The current active session for this match/flow (if any)
    activeSession() {
      return this.matchLivestreamSessions.find((s) =>
        s.flow_lifecycle_status === 'active' || s.session_status === 'active'
      ) || null
    },
    // Auto-deactivate deadline (ms epoch) set when source disconnects
    autoDeactivateAfterMs() {
      return (this.activeSession && this.activeSession.auto_deactivate_after) || null
    },
    autoDeactivateTimeStr() {
      if (!this.autoDeactivateAfterMs) return null
      return new Date(this.autoDeactivateAfterMs).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    // Source health from real-time EventBridge source health events (stored on inputs doc).
    // If the flow itself is not ACTIVE/STARTING, treat the source as offline regardless
    // of the last cached source-health event (which may be stale from before the stop).
    sourceHealthState() {
      if (!this.flowIsActive) return 'OFFLINE'
      return this.fixtureInput && this.fixtureInput.source_health_state
        ? String(this.fixtureInput.source_health_state).toUpperCase()
        : null
    },
    sourceHealthConnected() {
      return this.sourceHealthState === 'CONNECTED' || this.sourceHealthState === 'RECEIVING'
    },
    flowIsActive() {
      return this.flowStatus === 'ACTIVE' || this.flowStatus === 'UPDATING'
    },
    sourceHealthUnhealthy() {
      if (!this.flowIsActive) return false
      return Boolean(this.fixtureInput && this.fixtureInput.source_health_unhealthy)
    },
    sourceHealthTr101() {
      if (!this.flowIsActive) return null
      return (this.fixtureInput && this.fixtureInput.source_health_tr101) || null
    },
    // Active TR-101 error names for display
    activeTr101Errors() {
      const t = this.sourceHealthTr101
      if (!t) return []
      const labels = { ts_sync_loss: 'TS sync loss', continuity_count_error: 'Continuity count error', transport_error: 'Transport error', pcr_error: 'PCR error' }
      return Object.entries(labels).filter(([k]) => t[k]).map(([, v]) => v)
    },
    // Health state — prefer EventBridge source health (instant) over stale monitoringCurrent.state.
    // If the flow is stopped, always report offline regardless of cached event data.
    displayHealthState() {
      if (!this.flowIsActive) return 'offline'
      if (this.sourceHealthState) {
        if (!this.sourceHealthConnected) return 'offline'
        if (this.sourceHealthUnhealthy) return 'degraded'
        return 'healthy'
      }
      return (this.monitoringCurrent && this.monitoringCurrent.state) || 'unknown'
    },
    // Best available video metadata — only shown when source is connected.
    // If we have a definitive disconnected state from EventBridge, suppress stale cached values.
    displaySourceMetadataVideo() {
      if (this.sourceHealthState && !this.sourceHealthConnected) return null
      if (this.inputFlowStatus && this.inputFlowStatus.sourceMetadata && this.inputFlowStatus.sourceMetadata.video) {
        return this.inputFlowStatus.sourceMetadata.video
      }
      return (this.fixtureInput && this.fixtureInput.source_metadata_video) || null
    },
    displaySourceMetadataAudio() {
      if (this.sourceHealthState && !this.sourceHealthConnected) return null
      if (this.inputFlowStatus && this.inputFlowStatus.sourceMetadata && this.inputFlowStatus.sourceMetadata.audio) {
        return this.inputFlowStatus.sourceMetadata.audio
      }
      return (this.fixtureInput && this.fixtureInput.source_metadata_audio) || null
    },
    displaySourceBitrateKbps() {
      const toKbps = (value) => {
        const n = Number(value)
        if (!Number.isFinite(n) || n <= 0) return null
        return n > 100000 ? Math.round(n / 1000) : Math.round(n)
      }
      const video = this.displaySourceMetadataVideo
      if (video) {
        const videoKbps = toKbps(video.bitrateKbps)
        if (videoKbps != null) return videoKbps
        const videoBitrate = toKbps(video.bitrate)
        if (videoBitrate != null) return videoBitrate
      }
      if (this.monitoringVideo && Number.isFinite(this.monitoringVideo.bitrateKbps)) {
        return Math.round(this.monitoringVideo.bitrateKbps)
      }
      const source = this.inputFlowStatus && this.inputFlowStatus.source
      if (source) {
        const sourceKbps = toKbps(source.bitrateKbps)
        if (sourceKbps != null) return sourceKbps
        const sourceBitrate = toKbps(source.bitrate)
        if (sourceBitrate != null) return sourceBitrate
      }
      const flowStatus = this.inputFlowStatus || {}
      const directKbps = toKbps(flowStatus.bitrateKbps)
      if (directKbps != null) return directKbps
      const directBitrate = toKbps(flowStatus.bitrate)
      if (directBitrate != null) return directBitrate
      return null
    },
    displaySourceMessages() {
      if (this.sourceHealthState && !this.sourceHealthConnected) return []
      return (this.inputFlowStatus && this.inputFlowStatus.sourceMetadata && this.inputFlowStatus.sourceMetadata.messages) || []
    },
    vmixSrtHost() {
      const fromSource = (
        this.inputFlowStatus &&
        this.inputFlowStatus.source &&
        this.inputFlowStatus.source.ingestIp
      ) || ''
      if (fromSource) return fromSource
      const display = (this.inputFlowStatus && this.inputFlowStatus.ingestDisplay) || ''
      if (typeof display === 'string' && display.includes(':')) {
        return display.split(':')[0] || 'Unavailable'
      }
      return 'Unavailable'
    },
    vmixSrtPort() {
      const p = this.inputFlowStatus &&
        this.inputFlowStatus.source &&
        this.inputFlowStatus.source.listenerPort
      if (p) return p
      const display = (this.inputFlowStatus && this.inputFlowStatus.ingestDisplay) || ''
      if (typeof display === 'string') {
        const m = display.match(/:(\d+)\s*$/)
        if (m && m[1]) return Number(m[1])
      }
      if (this.isMediaConnectInput) return 5000
      return 'Unavailable'
    },
    vmixSrtMode() {
      const protocol = String(
        (this.inputFlowStatus &&
          this.inputFlowStatus.source &&
          this.inputFlowStatus.source.protocol) || ''
      ).toLowerCase()
      if (protocol.includes('listener')) return 'Caller'
      if (protocol.includes('caller')) return 'Listener'
      return 'Caller'
    },
    vmixSrtEndpoint() {
      if (this.vmixSrtHost === 'Unavailable' || this.vmixSrtPort === 'Unavailable') return 'Unavailable'
      return `srt://${this.vmixSrtHost}`
    },
    monitoringStreamDoc() {
      if (!this.activeLivestreamSessionId) return null
      return this.$store.getters["livestreams/byId"](this.activeLivestreamSessionId) || null
    },
    monitoringCurrent() {
      const doc = this.monitoringStreamDoc
      return (doc && doc.monitoring && doc.monitoring.current) || null
    },
    monitoringVideo() {
      return (this.monitoringCurrent && this.monitoringCurrent.video) || null
    },
    monitoringAlarms() {
      return this.$store.getters["livestreams/monitoringAlarms"] || []
    },
    activeMonitoringAlarms() {
      const active = (this.monitoringCurrent && this.monitoringCurrent.activeAlarms) || []
      return Array.isArray(active) ? active : []
    },
    // Content quality flags from the inputs doc (updated via EventBridge, near real-time)
    contentQualityImpacted() {
      if (!this.flowIsActive) return false
      return Boolean(this.fixtureInput && this.fixtureInput.content_quality_impacted)
    },
    contentQualityFlags() {
      if (!this.flowIsActive) return []
      const flags = (this.fixtureInput && this.fixtureInput.content_quality_flags) || []
      const labels = {
        black_frames_duration_breaching: 'Black frames',
        frozen_frames_duration_breaching: 'Frozen frames',
        silent_audio_duration_breaching: 'Silent audio',
        audio_missing: 'Audio missing',
        video_missing: 'Video missing',
      }
      return flags.map((f) => labels[f] || f)
    },
    collections() {
      return this.$store.getters["collections/array"];
    },
    canAddHighlightsToCollection() {
      const roles = (this.user && this.user.roles) || {};
      return Boolean(roles.archive_search && roles.archive_collections);
    },
    matchLivestreamSessions() {
      const all = Object.values((this.$store.state.livestreams && this.$store.state.livestreams.data) || {})
      return all
        .filter((s) => s && s.matchId === this.matchId)
        .sort((a, b) => {
          const aMs = (a.flow_started_at || a.session_started_at || a.activated_at || a.created_at)
          const bMs = (b.flow_started_at || b.session_started_at || b.activated_at || b.created_at)
          const aT = aMs && aMs.toMillis ? aMs.toMillis() : 0
          const bT = bMs && bMs.toMillis ? bMs.toMillis() : 0
          return bT - aT
        })
    },
  },
  watch: {
    inputFlowPollKey: {
      immediate: true,
      handler(newKey, oldKey) {
        if (!newKey) {
          this.stopInputFlowPolling()
          this.inputFlowStatus = null
          return
        }
        const resetStatus = this.inputIdFromFlowPollKey(newKey) !== this.inputIdFromFlowPollKey(oldKey)
        this.startInputFlowPolling(resetStatus)
      },
    },
    activeLivestreamSessionId: {
      immediate: true,
      handler() {
        this.refreshLivestreamAlarms()
      },
    },
    'match.ground': {
      immediate: true,
      handler(groundId) {
        this.ensureVenueLoaded(groundId);
      },
    },
    match: {
      immediate: true,
      handler(val) {
        if (!this.isSuperAdmin || !val || this.liveRoutingSaving) return
        this.syncLiveRoutingFormFromMatch()
      },
    },
    canStopEncoder(isActive, wasActive) {
      if (isActive && !wasActive) {
        this.$notify({
          message: 'Flow is live — ready to connect',
          type: 'success',
          timeout: 6000,
          overlap: true,
          verticalAlign: 'bottom',
          horizontalAlign: 'right',
        })
      }
    },
    liveRoutingInputId(val, old) {
      if (this.liveRoutingSyncing || val === old) return
      this.saveLiveRouting()
    },
    liveRoutingTakerIds(val, old) {
      if (this.liveRoutingSyncing) return
      if (JSON.stringify(val) === JSON.stringify(old)) return
      this.saveLiveRouting()
      this.takersDirtyForOutputs = true
    },
  },
  components: {
    tab, tabs,
    "archive-upload-wrapper": ArchiveUploader,
    "reel-card": ReelCard,
    "archive-clip": ArchiveClip,
    StreamClip,
  },
  beforeMount() {
    this.$store.dispatch("matches/fetchById", this.$route.params.id);
    this.$store
      .dispatch("livestreams/openDBChannel", {
        clauses: { where: [["matchId", "==", this.matchId]], limit: 80 },
      })
      .catch(console.error);
    this.$store.dispatch("takers/fetchAndAdd");
    this.$store.dispatch("inputs/openDBChannel").catch(console.error);
    this.$store.dispatch("files/openDBChannel", {
      where: [["match", "==", this.matchId]],
    });
    this.$store.dispatch("archiveEvents/fetchAndAdd", {
      where: [["match", "==", this.matchId], ["source", "==", "user"]],
    });
    this.$store.dispatch("collections/fetchAndAdd", { limit: 0 });

  },
  beforeDestroy() {
    this.stopInputFlowPolling();
    this.$store.dispatch("livestreams/closeDBChannel").catch(() => {});
    this.$store.dispatch("inputs/closeDBChannel").catch(() => {});
  },
  methods: {
    ensureVenueLoaded(groundId) {
      if (groundId == null || groundId === '') return;
      const id = String(groundId);
      if (this.$store.getters['venues/byId'](id)) return;
      if (this.requestedVenueId === id) return;
      this.requestedVenueId = id;
      this.$store.dispatch('venues/fetchById', id).catch(() => {});
    },
    livestreamInputOptionLabel(inp) {
      if (!inp) return '';
      const type =
        inp.type === 'mediaconnect'
          ? 'MC'
          : inp.type === 'medialive'
            ? 'ML'
            : inp.type === 'brightcove'
              ? 'BC'
              : inp.type || '?';
      return `${inp.name || inp.id} [${type}]`;
    },
    defaultTakeBbcCommsForTaker(takerId) {
      const t = this.$store.getters['takers/byId'](takerId);
      if (!t) return true;
      if (t.bbcAudioAllowed !== undefined) return t.bbcAudioAllowed !== false;
      if (t.defaultTakeBbcComms !== undefined) return t.defaultTakeBbcComms !== false;
      return true;
    },
    syncLiveRoutingFormFromMatch() {
      if (!this.isSuperAdmin) return;
      const m = this.match;
      if (!m) return;
      this.liveRoutingSyncing = true;
      this.liveRoutingInputId = m.livestreamInputId || null;
      const rows = Array.isArray(m.livestreamTakerRoutes) ? m.livestreamTakerRoutes : [];
      this.liveRoutingTakerIds = rows
        .filter((r) => r && r.takerId && r.enabled !== false)
        .map((r) => r.takerId);
      this.$nextTick(() => { this.liveRoutingSyncing = false; });
    },
    async saveLiveRouting() {
      if (!this.isSuperAdmin || !this.matchId || this.liveRoutingSaving) return;
      if (
        this.canStopEncoder &&
        this.liveRoutingInputId !== (this.match.livestreamInputId || null)
      ) {
        const ok = window.confirm(
          'The encoder is running. Changing the input profile here updates the fixture only; it does not move the live signal to another flow. Stop the encoder first if you need to switch flows. Save anyway?'
        );
        if (!ok) return;
      }
      this.liveRoutingSaving = true;
      try {
        const desiredInputId = this.liveRoutingInputId ? String(this.liveRoutingInputId).trim() : null;
        const publish = Firebase.app()
          .functions('europe-west2')
          .httpsCallable('bulkApplyMatchTakers');
        await publish({
          matchIds: [this.matchId],
          takerIds: Array.isArray(this.liveRoutingTakerIds) ? this.liveRoutingTakerIds : [],
          livestreamInputId: desiredInputId,
          mode: 'replace',
        });
        await this.$store.dispatch('matches/fetchById', this.matchId);
        const refreshed = this.$store.getters['matches/byId'](this.matchId);
        const refreshedInputId =
          refreshed && refreshed.livestreamInputId ? String(refreshed.livestreamInputId).trim() : null;
        if (refreshedInputId !== desiredInputId) {
          await this.$store.dispatch('matches/patch', {
            id: this.matchId,
            livestreamInputId: desiredInputId,
          });
          await this.$store.dispatch('matches/fetchById', this.matchId);
        }
        this.syncLiveRoutingFormFromMatch();
        this.pollInputFlowStatus();
      } catch (e) {
        console.error(e);
        this.$notify({
          message: (e && e.message) || 'Save failed',
          type: 'danger',
          timeout: 5000,
          overlap: true,
          verticalAlign: 'bottom',
          horizontalAlign: 'right',
        });
      } finally {
        this.liveRoutingSaving = false;
      }
    },
    applyMediaConnectFlowOutputs() {
      if (!this.isSuperAdmin || !this.isMediaConnectInput || !this.canStopEncoder) return;
      this.liveRoutingApplyOutputs = true;
      const publish = Firebase.app()
        .functions('europe-west2')
        .httpsCallable('reconcileMatchFlowOutputs');
      publish({ matchId: this.matchId })
        .then((res) => {
          const r = res && res.data && res.data.outputWiringResult;
          const detail = r
            ? `Added ${r.added}, updated ${r.updated}, removed ${r.removed}.`
            : '';
          this.$notify({
            message: detail ? `Flow outputs updated. ${detail}` : 'Flow outputs updated',
            type: 'success',
            timeout: 5000,
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          });
          this.takersDirtyForOutputs = false;
          this.pollInputFlowStatus();
        })
        .catch((e) => {
          console.error(e);
          this.$notify({
            message: (e && e.message) || 'Could not update flow outputs',
            type: 'danger',
            timeout: 6000,
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          });
        })
        .finally(() => {
          this.liveRoutingApplyOutputs = false;
        });
    },
    inputIdFromFlowPollKey(key) {
      if (!key) return null
      if (String(key).startsWith('pending:')) return String(key).slice(8)
      const idx = String(key).indexOf(':')
      return idx > 0 ? String(key).slice(0, idx) : String(key)
    },
    formatBrightcoveTakerStatus(takerId) {
      const row = this.brightcoveTakerStatusById[takerId]
      if (!row) {
        if (this.inputFlowLoading || this.inputFlowInFlight) return 'Loading…'
        if (!this.inputFlowStatus && this.inputFlowPollKey) return 'Loading…'
        return 'Unknown'
      }
      if (row.status === 'missing_live_asset_id') return 'Missing live asset ID'
      if (row.status === 'error') return 'Status error'
      return row.status || 'Unknown'
    },
    stopInputFlowPolling() {
      if (this.inputFlowPollTimer) {
        clearInterval(this.inputFlowPollTimer)
        this.inputFlowPollTimer = null
      }
    },
    startInputFlowPolling(resetStatus = true) {
      this.stopInputFlowPolling()
      if (resetStatus) {
        this.inputFlowStatus = null
        this.inputFlowErrorMessage = ''
      }
      if (!this.inputFlowPollKey) return
      this.pollInputFlowStatus()
      this.inputFlowPollTimer = setInterval(() => {
        this.pollInputFlowStatus()
      }, 60000)
    },
    pollInputFlowStatus() {
      const inputId = this.match && this.match.livestreamInputId
      if (!inputId) return
      const inp = this.fixtureInput
      if (inp && String(inp.type || '').toLowerCase() !== 'mediaconnect') return
      if (this.inputFlowInFlight) return
      const isInitialLoad = !this.inputFlowStatus
      if (isInitialLoad) this.inputFlowLoading = true
      this.inputFlowInFlight = true
      const publish = Firebase.app().functions('europe-west2').httpsCallable('getInputFlowStatus')
      publish({
        inputId: String(inputId).trim(),
        flowArn: inp && inp.aws_flow_arn,
        matchId: this.matchId,
      })
        .then((res) => {
          this.inputFlowStatus = (res && res.data) || null
          this.inputFlowErrorMessage = ''
          this.refreshLivestreamAlarms()
        })
        .catch((e) => {
          console.error(e)
          this.inputFlowErrorMessage = (e && e.message) || 'Unable to fetch MediaConnect flow status'
        })
        .finally(() => {
          this.inputFlowInFlight = false
          this.inputFlowLoading = false
        })
    },
    refreshLivestreamAlarms() {
      if (!this.activeLivestreamSessionId) {
        this.$store.commit('livestreams/setMonitoringAlarms', [])
        return
      }
      this.monitoringAlarmLoading = true
      this.$store.dispatch('livestreams/getLivestreamAlarms', {
        streamId: this.activeLivestreamSessionId,
        limit: 12,
      }).finally(() => {
        this.monitoringAlarmLoading = false
      })
    },
    openActivateEncoderModal() {
      this.activateHasBbcAudio = null
      this.activateHasSponsorAds = null
      this.showActivateEncoderModal = true
    },
    confirmActivateEncoder() {
      if (!this.hasActivatableInput) return
      if (this.activateHasBbcAudio === null || this.activateHasSponsorAds === null) return
      this.activatingEncoder = true
      let activatePromise
      if (this.isMediaConnectInput) {
        const publish = Firebase.app().functions('europe-west2').httpsCallable('flowControl')
        activatePromise = publish({
          action: 'activate',
          matchId: this.matchId,
          inputId: this.fixtureInput && this.fixtureInput.id,
          flowArn: this.fixtureInput && this.fixtureInput.aws_flow_arn,
          bbcCommsDeclared: this.activateHasBbcAudio === true,
          commercialisedDeclared: this.activateHasSponsorAds === true,
        }).then((res) => {
          this.inputFlowStatus = (res && res.data) || this.inputFlowStatus
          return res
        })
      } else {
        activatePromise = Promise.reject(new Error('No MediaConnect input configured for this match'))
      }
      activatePromise
        .then((res) => {
          this.showActivateEncoderModal = false
          this.inputFlowErrorMessage = ''
          const payload = res && res.data
          const newStreamId = payload && (payload.sessionId || payload.id)
          this.$store.dispatch('matches/fetchById', this.matchId)
          const streamIdToFetch = newStreamId || this.activeLivestreamSessionId
          if (streamIdToFetch) {
            this.$store.dispatch('livestreams/getStream', {
              id: streamIdToFetch,
              matchId: this.matchId,
            })
          }
          this.pollInputFlowStatus()
          this.$notify({
            message: 'Encoder activation started',
            timeout: 3000,
            type: 'success',
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          })
        })
        .catch((e) => {
          this.inputFlowErrorMessage = (e && e.message) || 'Unable to activate input'
          this.$notify({
            message: e && e.message ? e.message : 'Activation failed',
            timeout: 5000,
            type: 'danger',
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          })
        })
        .finally(() => {
          this.activatingEncoder = false
        })
    },
    stopEncoder() {
      if (!this.isMediaConnectInput || this.stoppingEncoder) return
      this.stoppingEncoder = true
      const publish = Firebase.app().functions('europe-west2').httpsCallable('flowControl')
      publish({
        action: 'deactivate',
        matchId: this.matchId,
        inputId: this.fixtureInput && this.fixtureInput.id,
        flowArn: this.fixtureInput && this.fixtureInput.aws_flow_arn,
      })
        .then((res) => {
          this.inputFlowStatus = (res && res.data) || this.inputFlowStatus
          this.inputFlowErrorMessage = ''
          this.$store.dispatch('matches/fetchById', this.matchId)
          this.refreshLivestreamAlarms()
          this.pollInputFlowStatus()
          this.$notify({
            message: 'Encoder stopped',
            timeout: 3000,
            type: 'success',
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          })
        })
        .catch((e) => {
          this.inputFlowErrorMessage = (e && e.message) || 'Unable to stop input'
          this.$notify({
            message: e && e.message ? e.message : 'Stop failed',
            timeout: 5000,
            type: 'danger',
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          })
        })
        .finally(() => {
          this.stoppingEncoder = false
        })
    },
    sessionTimestamp(ts) {
      if (!ts) return '—'
      const d = ts.toDate ? ts.toDate() : new Date(ts)
      if (Number.isNaN(d.getTime())) return '—'
      return d.toLocaleString('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London',
      })
    },
    formatStreamDuration(ms) {
      if (!ms || ms <= 0) return ''
      const totalSec = Math.round(ms / 1000)
      const h = Math.floor(totalSec / 3600)
      const m = Math.floor((totalSec % 3600) / 60)
      const s = totalSec % 60
      if (h > 0) return `${h}h ${m}m`
      if (m > 0) return `${m}m ${s}s`
      return `${s}s`
    },
    copyVmixEndpoint() {
      if (!this.vmixSrtEndpoint || this.vmixSrtEndpoint === 'Unavailable') return
      navigator.clipboard.writeText(this.vmixSrtEndpoint)
        .then(() => {
          this.$notify({
            message: 'Endpoint copied',
            timeout: 2500,
            type: 'success',
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          })
        })
        .catch(() => {
          this.$notify({
            message: 'Could not copy endpoint',
            timeout: 3500,
            type: 'danger',
            overlap: true,
            verticalAlign: 'bottom',
            horizontalAlign: 'right',
          })
        })
    },
    uniquePropertyValues(array, property) {
      return array.reduce((uniqueValues, obj) => {
        uniqueValues.add(obj[property]);
        return uniqueValues;
      }, new Set());
    },
    async sendStreamClipToCollection(clip) {
      if (!clip || !clip.id) return;
      if (!this.selectedStreamCollectionId) {
        this.$notify({
          type: "warning",
          title: "Collection required",
          message: "Choose a collection before sending clips.",
        });
        return;
      }
      if (clip.colID === this.selectedStreamCollectionId) {
        this.$notify({
          type: "info",
          title: "Already linked",
          message: "This clip is already in the selected collection.",
        });
        return;
      }
      this.$set(this.streamClipCollectionPatchInFlight, clip.id, true);
      try {
        await this.$store.dispatch("files/patch", {
          id: clip.id,
          colID: this.selectedStreamCollectionId,
        });
        this.$notify({
          type: "success",
          title: "Clip linked",
          message: "Stream clip sent to collection.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Send failed",
          message:
            (error && error.message) ||
            "Could not send this stream clip to the selected collection.",
        });
      } finally {
        this.$set(this.streamClipCollectionPatchInFlight, clip.id, false);
      }
    },
    async sendHighlightToCollection(file) {
      if (!this.canAddHighlightsToCollection) return;
      if (!file || !file.id) return;
      if (!this.selectedHighlightCollectionId) {
        this.$notify({
          type: "warning",
          title: "Collection required",
          message: "Choose a collection before adding highlights.",
        });
        return;
      }
      if (file.colID === this.selectedHighlightCollectionId) {
        this.$notify({
          type: "info",
          title: "Already linked",
          message: "This highlight is already in the selected collection.",
        });
        return;
      }
      this.$set(this.highlightCollectionPatchInFlight, file.id, true);
      try {
        await this.$store.dispatch("files/patch", {
          id: file.id,
          colID: this.selectedHighlightCollectionId,
        });
        this.$notify({
          type: "success",
          title: "Highlight linked",
          message: "Highlight added to collection.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Add failed",
          message:
            (error && error.message) ||
            "Could not add this highlight to the selected collection.",
        });
      } finally {
        this.$set(this.highlightCollectionPatchInFlight, file.id, false);
      }
    },
  },
};
</script>

<style scoped>
/* 
.card{
  position: inherit;
} */
</style>